import * as React from 'react';
import ImageOverlay from '../ImageOverlay';
import { ImageObject } from '../../utils/types';
import { SortableContainer, SortableElement, SortOver } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { ImageWrapper, AllImagesWrapper, Container, Header } from './Elements';
import { X } from 'react-feather';

type Props = {
  heading?: string;
  buttonText?: string;
  loading?: boolean;
  onButtonPress?: () => void;
  onClickConfirm: (d: ImageObject[]) => void;
  onOrderPress?: () => void;
  data?: ImageObject[];
};

type State = {
  items: ImageObject[];
};

const reducer = (state: State, newState: any) => {
  return {
    ...state,
    ...newState,
  };
};

const SortableItem = SortableElement(({ value, loading }: { value: ImageObject; loading?: boolean }) => (
  <ImageWrapper>
    <Container src={value && value.scaled} />
    <ImageOverlay loading={loading} top={true} reorder={true} noText={true} />
  </ImageWrapper>
));

const ImageContainer = SortableContainer(({ values }: { values: ImageObject[] }) => {
  return (
    <AllImagesWrapper>
      {values &&
        values.map((value: { scaled: string; id: string }, index: number) => {
          return <SortableItem key={`item-${index}`} value={value} index={index} />;
        })}
    </AllImagesWrapper>
  );
});

const Gallery: React.FC<Props> = ({ data, heading, loading, onButtonPress, buttonText, onClickConfirm }) => {
  const initialState = {
    items: data,
  };

  const [state, setState] = React.useReducer(reducer, initialState);
  const { items } = state;

  const onSortEnd = ({ oldIndex, newIndex }: SortOver) => {
    const newArray = arrayMove(items, oldIndex, newIndex);
    setState({ items: newArray });
  };

  return (
    <React.Fragment>
      <Header
        onClickConfirm={() => onClickConfirm(items)}
        icon={<X size={20} color="white" />}
        loading={loading}
        heading={heading}
        buttonText={buttonText}
        onButtonPress={onButtonPress}
      />
      <ImageContainer onSortEnd={onSortEnd} values={items} axis="xy" />
    </React.Fragment>
  );
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/DragDropGallery.tsx